module.exports = __webpack_public_path__ + "img/call.f80dfb53.svg";